import React, { Component } from 'react';
import ValidationSection from './validation_section';
import ValidationError from './validation_error';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

export default class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDay: props.selectedDay,
      pageWidth: window.innerWidth,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedDay !== this.props.selectedDay) {
      this.setState({ selectedDay: this.props.selectedDay });
    }
  }

  renderDay = (date, modifiers, dayProps) => {
    const isSelected = this.state.selectedDay && moment(this.state.selectedDay).isSame(date, 'day');
    const formattedDate = moment(date).format('DD');

    const holiday = this.props.holidays.find((h) => moment(h.date).isSame(date, 'day'));
    const tooltip = holiday ? 'Bank holiday' : '';

    let containerClass = '';
    if (holiday) {
      containerClass = isSelected ? 'holiday-container holiday DayPicker-Day--selected' : 'holiday-container holiday';
    }

    return (
      <div className={containerClass} key={date} {...dayProps}>
        <div className="day-number">{formattedDate}</div>
        {tooltip && <div className="holiday-tooltip">{tooltip}</div>}
      </div>
    );
  };

  render() {
    return (
      <div className="date-picker">
        <DayPicker
          firstDayOfWeek={1}
          fromMonth={new Date()}
          initialMonth={this.props.initialMonth || this.props.selectedDay}
          toMonth={this.finalMonth}
          selectedDays={this.state.selectedDay}
          disabledDays={this.props.disabledDays || { before: this.earliestAvailable }}
          onDayClick={this.handleDayClick}
          numberOfMonths={this.props.numberOfMonths || this.monthsForScreenSize}
          modifiers={{ holiday: this.observedHolidays }}
          renderDay={this.renderDay}
        />
        <ValidationSection className="date-container validation-error--v2" errors={this.props.errors}>
          <ValidationError errors={this.props.errors} />
        </ValidationSection>
      </div>
    );
  }

  handleDayClick = (day, modifiers = {}) => {
    if (modifiers.disabled) {
      return;
    }

    const selectedDay = modifiers.selected ? undefined : day;

    this.setState({ selectedDay }, () => {
      this.props.onChange(moment(this.state.selectedDay).format(this.props.dateFormat));
    });
  };

  get finalMonth() {
    return moment
      .max([moment(), moment(this.earliestAvailable)])
      .add(3, 'months')
      .toDate();
  }

  get observedHolidays() {
    return this.props.holidays.map((holiday) => new Date(holiday.date));
  }

  get earliestAvailable() {
    if (this.props.availableDate) {
      return this.props.availableDate.toDate();
    }

    return null;
  }

  get monthsForScreenSize() {
    return this.state.pageWidth < 768 ? 1 : 2;
  }
}
